<div *ngFor="let detail of report; let last = last">
	<p>
		<span>{{ detail?.message | getText }}</span>
		<span *ngIf="getOccurrences(detail); let occurrences">
			<span
				*ngIf="occurrences?.amount > 0 && occurrences?.pages !== '0' && occurrences?.pages; let pages"
			>
				<br />
				<span>({{ occurrences?.amount }} </span>
				<span i18n="@@PrintfileReportOccurrences"
					>{occurrences?.amount, plural, =1 {occurrence} other {occurrences}}</span
				>
				<span> on </span>
				<span i18n="@@PrintfileReportPages">{getPlural(pages), plural, =1 {page} other {pages}}</span>
				<span> {{ pages }}</span
				>)
			</span>
		</span>
	</p>
	<hr *ngIf="!last" />
</div>
